import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import { projects } from '../../data/projects';
import { useLanguage } from '../../i18n/LanguageContext';
import { pageStyle, containerStyle } from './pageStyles';

export const publishedProjects = projects.filter((p: any) => p.published);

const Projects = () => {
  const { t, pick, path } = useLanguage();
  const hasProjects = publishedProjects.length > 0;

  return (
    <div style={pageStyle}>
      <SEO
        title={t('seo.projects.title')}
        description={t('seo.projects.description')}
        canonicalPath="/projects"
        keywords={t('seo.projects.keywords')}
        // An empty projects index is a thin page — keep it out of the index
        // until real, approved case studies exist.
        noindex={!hasProjects}
      />
      <Navigation />

      <div style={containerStyle}>
        <nav aria-label="Breadcrumb" style={{ marginBottom: '1.5rem', fontSize: '0.875rem' }}>
          <ol style={{ listStyle: 'none', display: 'flex', gap: '0.5rem', padding: 0, margin: 0 }}>
            <li><Link to={path('/')} style={{ color: '#9ca3af', textDecoration: 'none' }}>{t('productPage.breadcrumbHome')}</Link></li>
            <li style={{ color: '#6b7280' }}>/</li>
            <li style={{ color: '#dfa926' }} aria-current="page">{t('projects.title')}</li>
          </ol>
        </nav>

        <h1 style={{ fontSize: '3rem', fontWeight: 'bold', color: 'white', marginBottom: '1.25rem', maxWidth: '56rem' }}>
          {t('projects.title')}
        </h1>
        <p style={{ fontSize: '1.25rem', color: '#d1d5db', maxWidth: '48rem', lineHeight: 1.7, marginBottom: '2.5rem' }}>
          {hasProjects ? t('projects.intro') : t('projects.empty')}
        </p>

        {hasProjects && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.25rem', marginBottom: '3rem' }}>
            {publishedProjects.map((p: any) => (
              <Link
                key={p.slug}
                to={path(`/projects/${p.slug}`)}
                style={{
                  background: 'linear-gradient(135deg, rgba(26, 26, 26, 0.5) 0%, rgba(17, 17, 17, 0.5) 100%)',
                  border: '1px solid rgba(58, 58, 58, 0.5)',
                  borderRadius: '0.75rem',
                  overflow: 'hidden',
                  textDecoration: 'none'
                }}
              >
                {p.images && p.images[0] && (
                  <img
                    src={p.images[0].src}
                    alt={pick(p.images[0], 'alt')}
                    loading="lazy"
                    style={{ width: '100%', height: '200px', objectFit: 'cover' as const, display: 'block' }}
                  />
                )}
                <div style={{ padding: '1.25rem' }}>
                  <span style={{ color: '#dfa926', fontWeight: 600 }}>{pick(p, 'title')}</span>
                  <p style={{ color: '#9ca3af', fontSize: '0.875rem', margin: '0.35rem 0 0 0' }}>
                    {pick(p, 'country')} · {pick(p, 'projectType')}
                  </p>
                  <span style={{ color: '#d1d5db', fontSize: '0.85rem' }}>{t('projects.readMore')} →</span>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div style={{ textAlign: 'center' as const, padding: '2rem 0' }}>
          <p style={{ color: '#d1d5db', marginBottom: '1rem' }}>{t('projects.ctaTitle')}</p>
          <Link
            to={path('/contact')}
            style={{ display: 'inline-block', backgroundColor: '#dfa926', color: 'black', fontWeight: 600, padding: '1rem 2.5rem', borderRadius: '0.5rem', textDecoration: 'none' }}
          >
            {t('projects.cta')}
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Projects;
